import { client } from './client';

export const aiManagementApi = {
  getAIPerformanceStats: (params) => client.get('ai_performance_stats', { params }),
  getAIAnswerReviewList: (params) => client.get('ai_answer_review_list', { params }),
  reviewAIAnswer: (params) => client.get('review_ai_answer', { params }),
  exportTrainingDataset: (params) => client.get('export_training_dataset', { params }),
  getAIStatistics: () => client.get('ai_statistics'),
  getDispatcherDepartmentOverview: () => client.get('dispatcher_department_overview'),
  submitResponseFeedback: (params) => client.get('submit_response_feedback', { params }),
  generateInsight: (prompt) => client.get('generate_insight', { params: { prompt } }),
};
